function reverseString(value) {
    return [...value].reverse().join('');
}

export { reverseString };
